import { render, staticRenderFns } from "./haikangAPP.vue?vue&type=template&id=11ef623c&"
import script from "./haikangAPP.vue?vue&type=script&lang=js&"
export * from "./haikangAPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports